module.exports = __webpack_public_path__ + "img/class.774afadb.svg";